/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './subsys.scss';
import './sms-wizard/sms-setup-wizard.scss';

/* eslint-disable import/no-unresolved, import/default */

import subsysTemplate from './subsys.tpl.html';
import addRelayTemplate from './add-relay.tpl.html';
import addSubsystemTemplate from './add-subsystem.tpl.html';
import addModbusDeviceTemplate from './add-modbus-device.tpl.html';
import smsSetupWizardTemplate from './sms-wizard/sms-setup-wizard.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.subsys', [])
    .directive('agSubsys', Subsys)
    .name;

/*@ngInject*/
function Subsys() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            subsys: '=',
            theForm: '=',
            userMode: '=',
            onManageCredentials: '&',
            onSubsysEditCancel: '&',
            onSubsysSave: '&'
        },
        controller: SubsysController,
        controllerAs: 'vm',
        templateUrl: subsysTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function SubsysController($element, $q, $scope, $filter, $mdDialog, $document, $timeout, agTypes, toast, $translate, $log, agDeviceService, deviceService) {

    let vm = this;
    $log.info('Subsys', vm);

    vm.agTypes = agTypes;
    vm.deviceCredentials = null;

    vm.onDeviceIdCopied = onDeviceIdCopied;
    vm.onAccessTokenCopied = onAccessTokenCopied;
    vm.getNumber = getNumber;
    vm.getSubsystemTitle = getSubsystemTitle;

    vm.manageCredentials = manageCredentials;

    vm.saveSubsys = saveSubsys;
    vm.cancelSubsysEdit = cancelSubsysEdit;

    vm.saveConnectionConfig = saveConnectionConfig;
    vm.saveHardwareConfig = saveHardwareConfig;
    vm.openSmsSetupWizard = openSmsSetupWizard;

    vm.toggleSubsystemStatus = toggleSubsystemStatus;

    vm.transformNetcontrollerIdChip = transformNetcontrollerIdChip;
    vm.updateLog = updateLog;
    vm.executeGwCommand = executeGwCommand;
    vm.executeRelaySystemComand = executeRelaySystemComand;
    vm.executeSmsCommand = executeSmsCommand;
    vm.sendCustomCommand = sendCustomCommand;
    vm.handleTabChange = handleTabChange;

    vm.selectedTab = 0;
    vm.selectedTabId = 0;
    vm.subsysConfigLogIntervalMs = null;
    vm.smsHardwareConfigTimeoutMs = null;
    vm.ttyPorts = [];

    vm.relays = [];
    vm.relaysQuery = {
        order: 'id'
    };
    vm.modbusDevices = [];
    vm.modbusDevicesQuery = {
        order: 'id'
    };

    vm.smsDevices = [];
    vm.smsDevicesQuery = {
        order: 'id'
    };

    vm.connectedSubsystems = [];
    vm.connectedSubsystemsStatuses = [];
    vm.connectedSubsystemsQuery = {
        order: 'id'
    };

    vm.logContentOptions = {
        useWrapMode: true,
        mode: 'java',
        showGutter: false,
        showPrintMargin: false,
        theme: 'github',
        advanced: {
            enableSnippets: false,
            enableBasicAutocompletion: false,
            enableLiveAutocompletion: false
        },
        onLoad: (_ace) => {
            vm.logEditor = _ace;

        }
    };

    vm.simulationContentOptions = {
        useWrapMode: true,
        mode: 'json',
        advanced: {
            enableSnippets: true,
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true
        }
    };

    vm.hardwareContentOptions = {
        useWrapMode: true,
        mode: 'json',
        advanced: {
            enableSnippets: true,
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true
        }
    };

    vm.logContent = '';
    vm.logContentOffset = 0;

    vm.commandOutputOptions = {
        useWrapMode: false,
        mode: 'json',
        showGutter: false,
        showPrintMargin: false,
        theme: 'github',
        advanced: {
            enableSnippets: false,
            enableBasicAutocompletion: false,
            enableLiveAutocompletion: false
        }
    };

    vm.commandOutput = '';
    vm.customCommandOutput = '';
    vm.ncLines = {};
    vm.ncSerials = {};
    vm.currentDate = new Date();

    vm.onRelaysReorder = onRelaysReorder;
    vm.addRelaySystemRelay = addRelaySystemRelay;
    vm.deleteSmsRelay = deleteSmsRelay;
    vm.onModbusDevicesReorder = onModbusDevicesReorder;
    vm.addModbusDevice = addModbusDevice;
    vm.deleteModbusDevice = deleteModbusDevice;
    vm.toggleSimulation = toggleSimulation;

    vm.onSMSDevicesReorder = onSMSDevicesReorder;
    vm.addSMSDevice = addSMSDevice;
    vm.deleteSMSDevice = deleteSMSDevice;

    vm.onConnectedSubsystemsReorder = onConnectedSubsystemsReorder;
    vm.addSubsystem = addSubsystem;
    vm.deleteConnectedSubsystem = deleteConnectedSubsystem;
    vm.onNcIdAdded = onNcIdAdded;

    vm.forceSubsystemsUpdate = forceSubsystemsUpdate;

    vm.subsysConfig = null;
    vm.subsysStatus = null;
    vm.commonConfig = null;
    vm.hardwareConfig = null;
    vm.simulation = false;
    vm.simulationConfig = null;
    vm.genericRequestBody = {
        callTimeout: 500
    };
    vm.genericCallParams = '{}';

    vm.gatewayId = null;

    function handleTabChange(tabId) {
        vm.selectedTabId = tabId;
    }

    $scope.$watch('vm.subsys', function(newVal) {
        if (newVal) {
            if (vm.subsys.id && vm.subsys.id.id) {
                deviceService.getDeviceCredentials(vm.subsys.id.id).then(
                    function success(credentials) {
                        vm.deviceCredentials = credentials;
                    }
                );
                if ($scope.gatewayIdWatch) {
                    $scope.gatewayIdWatch();
                }
                vm.gatewayId = null;
                if (vm.subsys.type == agTypes.deviceType.gateway) {
                    vm.gatewayId = vm.subsys.id.id;
                } else if (vm.subsys.type == agTypes.deviceType.sms || vm.subsys.type == agTypes.deviceType.generic || vm.subsys.type == agTypes.deviceType.relaySystem || vm.subsys.type == agTypes.deviceType.modbus) {
                    vm.gatewayId = vm.subsys.gatewayId;
                    $scope.gatewayIdWatch = $scope.$watch('vm.subsys.gatewayId', function(newVal, prevVal) {
                        if (newVal && !angular.equals(newVal, prevVal)) {
                            vm.gatewayId = vm.subsys.gatewayId;
                        }
                    });
                }
            }
        }
    });

    $scope.$watch('vm.gatewayId', function(newVal, prevVal) {
        if (newVal) {
            var promise = loadSubsysConfig();
            if ((vm.subsys.type == agTypes.deviceType.sms || vm.subsys.type == agTypes.deviceType.generic || vm.subsys.type == agTypes.deviceType.relaySystem || vm.subsys.type == agTypes.deviceType.modbus) && !angular.equals(newVal, prevVal)) {
                promise.then(
                    () => {
                        if (vm.theForm) {
                            vm.theForm.$setDirty();
                        }
                    },
                    () => {
                        if (vm.theForm) {
                            vm.theForm.$setDirty();
                        }
                    }
                );
            }
        }
    });

    if(!vm.userMode) {
        $scope.$watch('vm.selectedTabId', (newVal, prevVal) => {
            if (newVal && !angular.equals(newVal, prevVal)) {
                if (vm.subsys.type == agTypes.deviceType.gateway && vm.selectedTabId == 6 ||
                    (vm.subsys.type == agTypes.deviceType.sms || vm.subsys.type == agTypes.deviceType.relaySystem || vm.subsys.type == agTypes.deviceType.modbus) && vm.selectedTab == 5 || vm.subsys.type == agTypes.deviceType.generic && vm.selectedTab == 4) {
                    updateLog();
                }
            }
        });
    }

    /*
    vm.restartInNormalMode = function () {
        $log.info('restart in normal mode', vm.subsys, vm.subsysConfig);
        agDeviceService.saveSubsysConfig(vm.subsys, angular.toJson(vm.subsysConfig)).then(
            () => {
                agDeviceService.sendGatewayRpcCommand('subsys_fetch', {subsysid: vm.subsysConfig.id}, vm.gatewayId, 10000, (error) => {
                    showRpcError(error);
                }).then(
                    (responseBody) => {
                        return agDeviceService.processGatewayRpcResponse(responseBody, (error) => {
                            showRpcError(error);
                        });
                    },
                    () => {
                        //deferred.reject();
                    }
                );
            },
            () => {
            }
        );
    }*/

    $scope.$on('$destroy', () => {
        toast.hide();
    });

    function onModbusDevicesReorder() {
        updateModbusDevices();
    }

    function updateModbusDevices() {
        var result = $filter('orderBy')(vm.modbusDevices, vm.modbusDevicesQuery.order);
        vm.modbusDevices = result;
    }

    function addModbusDevice($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var excludeModbusDevicesIds = [];
        vm.modbusDevices.forEach((modbusDevice) => {
            excludeModbusDevicesIds.push(modbusDevice.id.id);
        });
        $mdDialog.show({
            controller: AddModbusDeviceController,
            controllerAs: 'vm',
            templateUrl: addModbusDeviceTemplate,
            parent: angular.element($document[0].body),
            locals: {
                excludeModbusDevicesIds: excludeModbusDevicesIds
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        }).then((modbusDevice) => {
            agDeviceService.addModbusDevice(vm.subsys.id, modbusDevice.id).then(
                () => {
                    vm.modbusDevices.push(modbusDevice);
                    updateModbusDevices();
                    vm.hardwareConfigForm.$setDirty();
                }
            );
        });
    }

    function deleteModbusDevice($event, modbusDevice) {
        if ($event) {
            $event.stopPropagation();
        }
        agDeviceService.deleteModbusRelation(modbusDevice.id, vm.subsys.id).then(
            () => {
                var index = vm.modbusDevices.indexOf(modbusDevice);
                if (index > -1) {
                    vm.modbusDevices.splice(index, 1);
                }
                vm.hardwareConfigForm.$setDirty();
            }
        );
    }



    // SMS DEVICES

    function onSMSDevicesReorder() {
        updateSMSDevices();
    }

    function updateSMSDevices() {
        var result = $filter('orderBy')(vm.smsDevices, vm.smsDevicesQuery.order);
        vm.smsDevices = result;
    }
    function addSMSDevice($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var excludeModbusDevicesIds = [];
        vm.smsDevices.forEach((modbusDevice) => {
            excludeModbusDevicesIds.push(modbusDevice.id.id);
        });
        $mdDialog.show({
            controller: AddModbusDeviceController,
            controllerAs: 'vm',
            templateUrl: addModbusDeviceTemplate,
            parent: angular.element($document[0].body),
            locals: {
                excludeModbusDevicesIds: excludeModbusDevicesIds
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        }).then((modbusDevice) => {
            agDeviceService.addSMSDevice(vm.subsys.id, modbusDevice.id).then(
                () => {
                    vm.smsDevices.push(modbusDevice);
                    //updateModbusDevices();
                    vm.hardwareConfigForm.$setDirty();
                }
            );
        });
    }

    function deleteSMSDevice($event, smsDevice) {
        if ($event) {
            $event.stopPropagation();
        }
        agDeviceService.deleteSMSRelation(smsDevice.id, vm.subsys.id).then(
            () => {
                var index = vm.smsDevices.indexOf(smsDevice);
                if (index > -1) {
                    vm.smsDevices.splice(index, 1);
                }
                vm.hardwareConfigForm.$setDirty();
            }
        );
    }



    function onRelaysReorder() {
        updateRelays();
    }

    function updateRelays() {
        var result = $filter('orderBy')(vm.relays, vm.relaysQuery.order);
        vm.relays = result;
    }

    function addRelaySystemRelay($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var excludeRelayIds = [];
        vm.relays.forEach((relay) => {
            excludeRelayIds.push(relay.id.id);
        });
        $mdDialog.show({
            controller: AddRelayController,
            controllerAs: 'vm',
            templateUrl: addRelayTemplate,
            parent: angular.element($document[0].body),
            locals: {
                excludeRelayIds: excludeRelayIds
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        }).then(function (relay) {
            agDeviceService.addRelaySystemRelay(vm.subsys.id, relay.id).then(
                () => {
                    vm.relays.push(
                        {
                            id: relay.id,
                            name: relay.name,
                            relayType: relay.relayType,
                            address: relay.address,
                            channelsNum: relay.channelsNum
                        }
                    );
                    updateRelays();
                    vm.hardwareConfigForm.$setDirty();
                }
            );
        }, function () {
        });
    }

    function deleteSmsRelay($event, relay) {
        if ($event) {
            $event.stopPropagation();
        }
        agDeviceService.deleteRelayRelation(relay.id, vm.subsys.id).then(
            () => {
                var index = vm.relays.indexOf(relay);
                if (index > -1) {
                    vm.relays.splice(index, 1);
                }
                vm.hardwareConfigForm.$setDirty();
            }
        );
    }

    function toggleSimulation() {
        if (vm.simulation) {
            vm.simulationConfig = '{}';
        } else {
            vm.simulationConfig = null;
        }
    }

    function onConnectedSubsystemsReorder () {
        updateConnectedSubsystems();
    }

    function updateConnectedSubsystems () {
        var result = $filter('orderBy')(vm.connectedSubsystems, vm.connectedSubsystemsQuery.order);
        vm.connectedSubsystems = result;
    }

    function addSubsystem($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var excludeSubsystemIds = [];
        vm.connectedSubsystems.forEach((subsys) => {
            excludeSubsystemIds.push(subsys.id.id);
        });
        $mdDialog.show({
            controller: AddSubsystemController,
            controllerAs: 'vm',
            templateUrl: addSubsystemTemplate,
            parent: angular.element($document[0].body),
            locals: {
                excludeSubsystemIds: excludeSubsystemIds
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        }).then(function (smsSubsystem) {
            agDeviceService.getParentGateway(smsSubsystem.id.id).then(
                (parentGateway) => {
                    if (parentGateway && parentGateway.id.id != vm.gatewayId) {
                        var title = $translate.instant('ag.gateway.unable-to-add-subsystem-title');
                        var content = $translate.instant('ag.gateway.unable-to-add-subsystem-message',
                            {smsSubsystem: smsSubsystem.name, gateway: parentGateway.name});
                        var alert = $mdDialog.alert()
                            .targetEvent($event)
                            .title(title)
                            .htmlContent(content)
                            .ariaLabel(title)
                            .ok($translate.instant('action.close'));
                        $mdDialog.show(alert);
                    } else {
                        agDeviceService.addConnectedSubsystem(vm.subsys.id, smsSubsystem.id).then(
                            () => {
                                vm.connectedSubsystems.push(smsSubsystem);
                                updateConnectedSubsystems();
                            }
                        );
                    }
                }
            );
        }, function () {
        });
    }

    function deleteConnectedSubsystem($event, subsystem) {
        if ($event) {
            $event.stopPropagation();
        }
        agDeviceService.deleteRelation(subsystem.id, vm.subsys.id).then(
            () => {
                var index = vm.connectedSubsystems.indexOf(subsystem);
                if (index > -1) {
                    vm.connectedSubsystems.splice(index, 1);
                }
            }
        );
    }

    function forceSubsystemsUpdate() {
        let title = $translate.instant('ag.gateway.force-subsystems-update');
        let content = $translate.instant('ag.gateway.force-subsystems-warning');
        let confirm = $mdDialog.confirm()
            .title(title)
            .htmlContent(content)
            .ariaLabel(content)
            .cancel($translate.instant('action.no'))
            .ok($translate.instant('action.yes'));
        $mdDialog.show(confirm).then(
            () => {
                // sendRpc('subsys_fetch_all').then(
                //     (responseBody) => {
                //         processRpcResponse(responseBody).then();
                //     }
                // );
                sendRpc('subsys_fetch_all', null, null, 3000, true);
            }
        );
    }

    function getNumber(num) {
        return new Array(num);
    }

    function getSubsystemTitle() {
        if(vm.subsys.type == vm.agTypes.deviceType.gateway) {
            return 'ag.gateway.gateway-subsystem';
        } else if(vm.subsys.type == vm.agTypes.deviceType.sms) {
            return 'ag.sms.sms-subsystem';
        } else if (vm.subsys.type == vm.agTypes.deviceType.generic) {
            return 'ag.generic.generic-subsystem';
        } else if (vm.subsys.type == vm.agTypes.deviceType.relaySystem) {
            return 'ag.relay.relay-subsystem';
        } else if (vm.subsys.type == vm.agTypes.deviceType.modbus) {
            return 'ag.modbus.modbus-subsystem';
        }
    }

    function onDeviceIdCopied () {
        toast.showSuccess($translate.instant('device.idCopiedMessage'), 750, $element.parent(), 'bottom left');
    }

    function onAccessTokenCopied () {
        toast.showSuccess($translate.instant('device.accessTokenCopiedMessage'), 750, $element.parent(), 'bottom left');
    }


    function manageCredentials($event) {
       if (vm.onManageCredentials) {
           vm.onManageCredentials({$event: $event, gateway: vm.gateway});
       }
    }

    function saveSubsys($event) {
        if (vm.onSubsysSave) {
            vm.onSubsysSave({$event: $event, subsys: vm.subsys});
        }
    }

    function cancelSubsysEdit() {
        if (vm.onSubsysEditCancel) {
            vm.onSubsysEditCancel({subsys: vm.subsys});
        }
    }

    function loadSubsysConfig() {
        var deferred = $q.defer();
        vm.ttyPorts.length = 0;
        vm.relays.length = 0;
        vm.modbusDevices.length = 0;
        vm.connectedSubsystems.length = 0;
        vm.logContent = '';
        vm.logContentOffset = 0;
        vm.commandOutput = '';
        vm.customCommandOutput = '';
        vm.ncLines = {};
        vm.ncSerials = {};
        agDeviceService.loadSubsysConfig(vm.subsys.id.id).then(
            (subsysConfig) => {
                vm.subsysConfig = subsysConfig;
                if (vm.subsys.type == agTypes.deviceType.sms || vm.subsys.type == agTypes.deviceType.relaySystem || vm.subsys.type == agTypes.deviceType.modbus) {
                    agDeviceService.loadSubsysConfig(vm.gatewayId).then(
                        (subsysConfig) => {
                            vm.gwSmsSubsysConfig = subsysConfig;
                            getListOfTtyPorts();
                            onLoadConfig(deferred);
                        },
                        () => {
                            onLoadConfigFailed(deferred);
                        }
                    );
                } else {
                    onLoadConfig(deferred);
                }
            },
            () => {
                onLoadConfigFailed(deferred);
            }
        );
        return deferred.promise;
    }

    function onLoadConfig(deferred) {
        getConnectedSystems().then(
            () => {
                processSubsysConfig();
                getSubsystemStatus();
                if (deferred) {
                    deferred.resolve();
                }
            },
            () => {
                processSubsysConfig();
                if (deferred) {
                    deferred.reject();
                }
            }
        );
    }

    function onLoadConfigFailed(deferred) {
        vm.subsysConfig = null;
        vm.gwSmsSubsysConfig = null;
        vm.subsysStatus = null;
        vm.commonConfig = null;
        vm.hardwareConfig = null;
        vm.simulation = false;
        vm.simulationConfig = null;
        resetConfigForms();
        parseSubsysParams();
        if (deferred) {
            deferred.reject();
        }
    }

    function processSubsysConfig() {
        vm.commonConfig = angular.copy(vm.subsysConfig);
        delete vm.commonConfig.hardware_config;
        vm.hardwareConfig = angular.copy(vm.subsysConfig.hardware_config);
        resetConfigForms();
        parseSubsysParams();
    }

    function parseSubsysParams() {
        if (vm.commonConfig) {
            vm.subsysConfigLogIntervalMs = vm.commonConfig.controller_config.log_interval * 1000;
            if (vm.subsys.type == agTypes.deviceType.sms) {
                vm.smsHardwareConfigTimeoutMs = vm.hardwareConfig.timeout * 1000;
                if (vm.hardwareConfig.simulation_config) {
                    vm.simulation = true;
                    vm.simulationConfig = angular.toJson(vm.hardwareConfig.simulation_config, true);
                } else {
                    vm.simulation = false;
                    vm.simulationConfig = null;
                }
            }
            if (vm.subsys.type == agTypes.deviceType.generic) {
                vm.genericConfig = angular.toJson(vm.hardwareConfig, true);
            }
        } else {
            vm.subsysConfigLogIntervalMs = null;
            vm.smsHardwareConfigTimeoutMs = null;
        }
    }

    function resetConfigForms () {
        if (vm.theForm) {
            vm.theForm.$setPristine();
            vm.theForm.$setUntouched();
        }
        if (vm.connectionForm) {
            vm.connectionForm.$setPristine();
            vm.connectionForm.$setUntouched();
        }
        if (vm.hardwareConfigForm) {
            vm.hardwareConfigForm.$setPristine();
            vm.hardwareConfigForm.$setUntouched();
        }
    }

    function saveConnectionConfig() {
        vm.commonConfig.controller_config.log_interval = vm.subsysConfigLogIntervalMs / 1000;
        var hardware_config = angular.copy(vm.subsysConfig.hardware_config);
        vm.subsysConfig = angular.copy(vm.commonConfig);
        vm.subsysConfig.hardware_config = hardware_config;
        agDeviceService.saveSubsysConfig(vm.subsys, angular.toJson(vm.subsysConfig)).then(
            () => {
                vm.connectionForm.$setPristine();
                vm.connectionForm.$setUntouched();
            },
            () => {
                vm.connectionForm.$setPristine();
                vm.connectionForm.$setUntouched();
            }
        );
    }

    function saveHardwareConfig() {
        if (vm.subsys.type == agTypes.deviceType.sms) {
            vm.hardwareConfig.timeout = vm.smsHardwareConfigTimeoutMs / 1000;
            if (vm.simulation) {
                vm.hardwareConfig.simulation_config = angular.fromJson(vm.simulationConfig);
            } else {
                delete vm.hardwareConfig.simulation_config;
            }
        }
        if (vm.subsys.type == agTypes.deviceType.relaySystem) {
            vm.hardwareConfig.relays = vm.relays ? vm.relays.map((relay) => {
                return {
                    address: relay.address,
                    device_id: relay.name,
                    type: relay.relayType,
                    n_channels: relay.channelsNum
                }}) : [];
        }
        if (vm.subsys.type == agTypes.deviceType.modbus) {
            vm.hardwareConfig.modbus_devices = [];
            vm.modbusDevices.forEach((modbusDevice) => {
                let device = {
                    device_name: modbusDevice.name,
                    type: modbusDevice.deviceType,
                    address: modbusDevice.address,
                    config: angular.fromJson(modbusDevice.config)
                };
                vm.hardwareConfig.modbus_devices.push(device);
            });

        }
        if (vm.subsys.type == agTypes.deviceType.sms) {
            vm.hardwareConfig.sms_devices = [];
            vm.smsDevices.forEach((modbusDevice) => {
                let device = {
                    device_name: modbusDevice.name,
                    type: modbusDevice.deviceType,
                    address: modbusDevice.address,
                    config: angular.fromJson(modbusDevice.config)
                };
                vm.hardwareConfig.sms_devices.push(device);
            });

        }
        
        if (vm.subsys.type == agTypes.deviceType.generic) {
            vm.hardwareConfig = angular.fromJson(vm.genericConfig);
        }
        vm.subsysConfig.hardware_config = angular.copy(vm.hardwareConfig);

        agDeviceService.saveSubsysConfig(vm.subsys, angular.toJson(vm.subsysConfig)).then(
            () => {
                vm.hardwareConfigForm.$setPristine();
                vm.hardwareConfigForm.$setUntouched();
            },
            () => {
                vm.hardwareConfigForm.$setPristine();
                vm.hardwareConfigForm.$setUntouched();
            }
        );
    }

    function openSmsSetupWizard($event) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'SmsSetupWizardController',
            controllerAs: 'vm',
            templateUrl: smsSetupWizardTemplate,
            parent: angular.element($document[0].body),
            locals: {
                ctx: vm.ctx,
                gatewayId: vm.gatewayId,
                subsys: vm.subsys,
                subsysConfig: vm.subsysConfig,
                subsysStatus: vm.subsysStatus,
                ttyPorts: vm.ttyPorts,
                userMode: vm.userMode
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        }).then(() => {
            toast.showSuccess($translate.instant('ag.sms.nc-configuration-done'), 5000, $element.parent(), 'bottom left');
            loadSubsysConfig().then(
                () => {

                }
            );
        }, () => {
        });
    }

    function getConnectedSystems() {
        var deferred = $q.defer();
        if (vm.subsys.type == agTypes.deviceType.relaySystem) {
            agDeviceService.getRelaySystemRelaysList(vm.subsys.id).then(
                (relays) => {
                    vm.relays = relays || [];
                    deferred.resolve();
                },
                () => {
                    deferred.reject();
                }
            );
        } else if (vm.subsys.type == agTypes.deviceType.modbus) {
            agDeviceService.getModbusDevicesList(vm.subsys.id).then(
                (modbusDevices) => {
                    vm.modbusDevices = modbusDevices || [];
                    deferred.resolve();
                },
                () => {
                    deferred.reject();
                }
            )
        } else if (vm.subsys.type == agTypes.deviceType.sms) {
            agDeviceService.getSMSDevicesList(vm.subsys.id).then(
                (modbusDevices) => {
                    $log.info('SMS devices', modbusDevices)
                    vm.smsDevices = modbusDevices || [];
                    deferred.resolve();
                },
                () => {
                    deferred.reject();
                }
            )
        } else if (vm.subsys.type == agTypes.deviceType.gateway) {
            agDeviceService.getConnectedSubsystemsList(vm.subsys.id).then(
                (connectedSubsystems) => {
                    vm.connectedSubsystems = connectedSubsystems || [];
                    sendRpc('subsys_status_all', null, null, 3000).then(
                        (responseBody) => {
                            processRpcResponse(responseBody).then(
                                (result) => {
                                    vm.connectedSubsystemsStatuses = result;
                                    vm.connectedSubsystemsStatuses.forEach((connectedSystem) => {
                                        let result = $filter('filter')(vm.connectedSubsystems, {name: connectedSystem.name}, true);
                                        if (result.length) {
                                            result[0].status = connectedSystem.statename;
                                        }
                                    });
                                    deferred.resolve();
                                },
                                () => {
                                    deferred.reject();
                                }
                            );
                        },
                        () => {
                            deferred.reject();
                        }
                    );
                },
                () => {
                    deferred.reject();
                }
            );
        } else {
            deferred.resolve()
        }
        return deferred.promise;
    }

    function getSubsystemStatus() {
        vm.subsysStatus = null;
        sendRpc('subsys_status', { subsysid: vm.subsysConfig.id }, null, 3000).then(
            (responseBody) => {
                processRpcResponse(responseBody).then((result) => {
                    vm.subsysStatus = result;
                });
            }
        );
    }

    function toggleSubsystemStatus() {
        if (vm.subsysStatus && vm.subsysStatus.statename) {
            if (vm.subsysStatus.statename == 'RUNNING') {
                stopSubsystem();
            } else {
                startSubsystem();
            }
        }
    }

    function stopSubsystem() {
        sendRpc('subsys_stop', { subsysid: vm.subsysConfig.id }).then(
            (responseBody) => {
                processRpcResponse(responseBody).then((/*result*/) => {
                    getSubsystemStatus();
                });
            }
        );
    }

    function startSubsystem() {
        sendRpc('subsys_start', { subsysid: vm.subsysConfig.id }, null, 2000).then(
            (responseBody) => {
                processRpcResponse(responseBody).then((/*result*/) => {
                    getSubsystemStatus();
                });
            }
        );
    }

    function getListOfTtyPorts() {
        sendRpc('system_list_ttyports', null, null, 3000).then(
            (responseBody) => {
                processRpcResponse(responseBody).then((result) => {
                    if (result && result.length) {
                        result.forEach((ttyPort) => {
                            vm.ttyPorts.push(ttyPort);
                        });
                    }
                });
            }
        );
    }

    function updateLog() {
        if (vm.subsysStatus) {
            var params = {
                subsysid: vm.subsysConfig.id,
                length: 20000,
                offset: 0//vm.logContentOffset
            };
            sendRpc('subsys_log_tail', params).then(
                (responseBody) => {
                    processRpcResponse(responseBody).then((result) => {
                        vm.logContent = result[0];
                       // vm.logContentOffset = result[1];
                       //  if (!result[2]) {
                       //      updateLog();
                       //  } else {
                       //      $timeout(() => {
                       //          if (vm.logEditor) {
                       //              var row = vm.logEditor.session.getLength() - 1;
                       //              var column = 0;//vm.logEditor.session.getLine(row).length;
                       //              vm.logEditor.selection.moveTo(row, column);
                       //          }
                       //      });
                       //  }
                        $timeout(() => {
                            if (vm.logEditor) {
                                var row = vm.logEditor.session.getLength() - 1;
                                var column = 0;//vm.logEditor.session.getLine(row).length;
                                vm.logEditor.selection.moveTo(row, column);
                            }
                        });
                    });
                }
            );
        }
    }

    function executeGwCommand(command, timeout) {
        vm.commandOutput = '';
        sendRpc(command, undefined, undefined, timeout).then(
            (responseBody) => {
                processRpcResponse(responseBody).then((result) => {
                    if (result) {
                        vm.commandOutput = angular.toJson(result, true);
                    }
                });
            }
        );
    }

    function executeRelaySystemComand(command, timeout) {
        vm.commandOutput = '';
        var params = {};
        sendRpc(command, params, vm.subsys.id.id, timeout).then(
            (responseBody) => {
                processRpcResponse(responseBody).then((result) => {
                    if (result) {
                        vm.commandOutput = angular.toJson(result, true);
                    }
                });
            }
        )
    }

    function executeSmsCommand() {
        vm.commandOutput = '';
        var params = {
        };
        var timeout = 3000;
        if (vm.smsCommand.command.hasNcId) {
            params['address'] = vm.smsCommand.netcontrollerId;
        }
        if (vm.smsCommand.command.hasLineId) {
            params['line_number'] = vm.smsCommand.lineId;
        }
        if (vm.smsCommand.command.hasSerial) {
            var serialInfo = vm.ncSerials[vm.smsCommand.netcontrollerId];
            var date = serialInfo.date;
            var day = date.getDate();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();
            var sub = serialInfo.subNum;
            params['day'] = pad(day);
            params['month'] = pad(month);
            params['year'] = pad(year).slice(-2);
            params['sub'] = pad(sub);
        }
        if(vm.smsCommand.command.value == vm.agTypes.command.sms.clear_nc.value) {
            timeout = 12000;
        }
        sendRpc(vm.smsCommand.command.value, params, vm.subsys.id.id, timeout).then(
            (responseBody) => {
                processRpcResponse(responseBody).then((result) => {
                    if (result) {
                        vm.commandOutput = angular.toJson(result, true);
                    }
                });
            }
        );
    }

    function sendCustomCommand() {
        vm.customCommandOutput = '';
        vm.genericRequestBody.callParams = angular.fromJson(vm.genericCallParams);
        sendRpc(vm.genericRequestBody.methodName, vm.genericRequestBody.callParams, vm.subsys.id.id, vm.genericRequestBody.callTimeout).then(
            (responseBody) => {
                processRpcResponse(responseBody).then((result) => {
                    if (result) {
                        vm.customCommandOutput = angular.toJson(result, true);
                    }
                });
            }
        )
    }

    function pad(d) {
        return (d < 10) ? '0' + d.toString() : d.toString();
    }

    function transformNetcontrollerIdChip(chip) {
        var value = Number(chip);
        if (isInteger(value) && value >= 1) {
            return value;
        } else {
            return null;
        }
    }

    function onNcIdAdded() {
        vm.hardwareConfigForm.$setDirty();
    }

    function isInteger(value) {
        return angular.isNumber(value)
            && Number.isFinite(value)
            && !(value % 1);
    }

    function processRpcResponse(responseBody) {
        return agDeviceService.processGatewayRpcResponse(responseBody, (error) => {
            showRpcError(error);
        });
    }

    function sendRpc(method, params, gatewayId, timeout, oneWay) {
        if (!gatewayId) {
            gatewayId = vm.gatewayId;
        }
        return agDeviceService.sendGatewayRpcCommand(method, params, gatewayId, timeout, (error) => {
            showRpcError(error);
        }, oneWay);
    }

    function showRpcError(error) {
        toast.showError(error, $element.parent(), 'bottom left');
    }

}

/*@ngInject*/
function AddRelayController($scope, $mdDialog, types, agTypes, agDeviceService, excludeRelayIds) {

    var vm = this;

    vm.types = types;
    vm.agTypes = agTypes;
    vm.excludeRelayIds = excludeRelayIds;

    vm.add = add;
    vm.cancel = cancel;

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        agDeviceService.getDevice({ entityType: types.entityType.device,
                                    id: vm.relayId }).then(
            function success(relay) {
                $scope.relayForm.$setPristine();
                $mdDialog.hide(relay);
            }
        );
    }
}

/*@ngInject*/
function AddSubsystemController($scope, $mdDialog, types, agTypes, agDeviceService, excludeSubsystemIds) {

    var vm = this;

    vm.types = types;
    vm.agTypes = agTypes;
    vm.excludeSubsystemIds = excludeSubsystemIds;
    vm.subsysDeviceTypes = [agTypes.deviceType.sms, agTypes.deviceType.relaySystem, agTypes.deviceType.modbus];

    vm.add = add;
    vm.cancel = cancel;

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        agDeviceService.getDevice({ entityType: types.entityType.device,
            id: vm.subsystemId }).then(
            function success(subsystem) {
                $scope.connectedSubsystemForm.$setPristine();
                $mdDialog.hide(subsystem);
            }
        );
    }
}

/*@ngInject*/
function AddModbusDeviceController($scope, $mdDialog, types, agTypes, agDeviceService,  excludeModbusDevicesIds) {// eslint-disable-line

    let vm = this;

    vm.types = types;
    vm.agTypes = agTypes;
    vm.excludeModbusDevicesIds = excludeModbusDevicesIds;
    vm.modbusDeviceTypes = [agTypes.deviceType.levelIndicator, agTypes.deviceType.weatherStation, agTypes.deviceType.headSpaceSensor];

    vm.add = add;
    vm.cancel = cancel;

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        agDeviceService.getDevice({entityType: types.entityType.device, id: vm.modbuDeviceId}).then(
            (modbusDevice) => {
                $scope.connectedModbusDevicesForm.$setPristine();
                $mdDialog.hide(modbusDevice);
            }
        );
    }
}
